import { useQuery } from "@tanstack/react-query";
import { fetchUsers } from "@/lib/firebaseFunctions";

export default function useUsers() {
    return useQuery({
        queryKey: ["users"],
        queryFn: fetchUsers,
    })

}